import { ZodType, ZodTypeDef } from "zod";

/**
 * Allows both null and undefined as input values in addition to the actual value,
 * but coerces them both to undefined.
 */
export function nullishToOptional<I, O>(type: ZodType<I, ZodTypeDef, O>) {
  return type.nullish().transform(t => t ?? undefined);
}
